
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mat-form-group',
  styleUrls: ['./form-group.component.scss'],
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None,
})
export class MatFormGroup { }
